import Country from "../../models/Country";
export const CountryMixin = {
  data() {
    return {
      country: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Country({
        name: null,
        acronym: null,
        acronym3: null,
        currency_acronym: null,
        reward_amount_of_new_user: 0,
        reward_amount_of_old_user: 0,
        reward_min_transfer_amount: 0,
        calling_code: null,
        is_for_secondary_currency: false,
        has_acceptable_id_document: true,
      })
    }
  }
}
